import React, { useCallback } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { TabProps } from "./Tab.props";
import styles from "./Tab.module.scss";

/**
 * @deprecated Use `import { TabSet } from capitalrx-components-2.0/lib/general` instead.
 */
const Tab: React.FC<TabProps> = (props: TabProps) => {
  const { id, className, title, disabled = false, isActive, isLoading, size = "large", onClick } = props;

  const tabClasses = cn(
    styles["tab-component"], // static class for css
    styles[size],
    className,
  );

  const activeTabClasses = cn(
    styles["tab-component"], // static class for css
    styles["active"],
    styles[size],
    className,
  );

  const loadingTabClasses = cn(styles["loading"], styles[size]);

  const handleOnClick = useCallback(
    (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
      ev.preventDefault();
      onClick && onClick(ev);
    },
    [onClick],
  );

  // Logic for different tab over all looks
  if (!isLoading) {
    return (
      <button
        id={id}
        data-testid={`test__${id}`}
        className={isActive && !disabled ? activeTabClasses : tabClasses}
        disabled={disabled}
        type="button"
        onClick={(ev): void => handleOnClick(ev)}
      >
        {title}
      </button>
    );
  }

  return <Skeleton className={loadingTabClasses} />;
};

/**
 * @deprecated
 */
export default Tab;
